module.exports = __webpack_public_path__ + "img/Logo BMS GESTAO - Definitiva.101399d5.png";